module.exports = __webpack_public_path__ + "static/media/Group 24445.fe0ca00e.svg";